import React from 'react';

import JsonLd from '../../shared/components/json-ld';

const getProductJsonLdImageData = (image) => image ? (image.cdn || image.lrg || image.sm) : null;
const getProductJsonLdImageArrayData = (images) => images instanceof Array ? ({
  image: images.map( img => getProductJsonLdImageData(img) )
}) : null;

const getProductJsonLdBrand = (brand)=> brand && ({
  brand: {
    "@type": "Thing",
    name: brand
   }
 })

 const getProductJsonLdRatings = (rating, numReviews) => !isNaN(rating) && !isNaN(numReviews) && numReviews > 0 && ({
   aggregateRating: {
     "@type": "AggregateRating",
     ratingValue: rating,
     reviewCount: numReviews
   }
 });

 const getProductJsonLdOffers = ({linkUrl, instock, salePrice, listPrice}) => (!isNaN(salePrice) || !isNaN(listPrice)) && ({
   "offers": {
     "@type": "Offer",
     "priceCurrency": "USD",
     price: salePrice || listPrice,
     ...linkUrl && { url: linkUrl },
     ...(typeof instock === 'boolean') && { availability: instock ? "https://schema.org/InStock" : "https://schema.org/OutOfStock" }
   }
 });

 // note: products from swiftype have a slightly different syntax.
 // For example, prdOverview would be in the root of the product rather than in the attributes field
 const getProductJsonLdData = ({name, images, sku, rating, numReviews, upc, brand, listPrice, salePrice, attributes, prdOverview, linkUrl, instock}) => {
   const { prdOverview : attributeProductOverview = {} } = attributes || {};

   const jsonLdData = {
     "@context": "https://schema.org/",
     "@type": "Product",
     "name": name,
     "sku": sku,
     "mpn": sku,
     ...((upc && {gtin: upc }) || {}),
     ...(attributeProductOverview || prdOverview) && { "description": attributeProductOverview || prdOverview },
     ...getProductJsonLdImageArrayData(images),
     ...getProductJsonLdBrand(brand),
     ...getProductJsonLdRatings(rating, numReviews),
     ...getProductJsonLdOffers({ instock, linkUrl, salePrice, listPrice })
   }
   return jsonLdData;
 }

 export default ({product}) => ( product && product.name && product.images && product.sku ) && ( product.salePrice || product.listPrice) ? (
   <JsonLd type="product" data={getProductJsonLdData({...product})} shouldNotUseDefaults={true} />
 ) : null;
